import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox, Form } from "antd";
import { useFormContentBlocker } from "../../../../contexts/formContentBlocker.js";
import { useI18n } from "../../../../contexts/i18n.js";
import { LearnMoreTag } from "../../../common/learnMoreTag.js";
const FormContentBlockerFieldTemplateCheck = ()=>{
    const { __, _x } = useI18n();
    const { templateCheck, isTemplateUpdate } = useFormContentBlocker();
    return !!(templateCheck || isTemplateUpdate) && /*#__PURE__*/ _jsx(Form.Item, {
        name: "templateCheck",
        valuePropName: "checked",
        required: true,
        rules: [
            {
                type: "boolean",
                required: true,
                transform: (value)=>value || undefined,
                message: __("Please confirm that you have checked the content of the content blocker.")
            }
        ],
        children: /*#__PURE__*/ _jsxs(Checkbox, {
            children: [
                _x("I have checked the information in the content blocker template myself for correctness and completeness and have added missing information or corrected information that does not fit my use case. I am aware that the manufacturer of Real Cookie Banner cannot take any liability in this respect.", "legal-text"),
                " ",
                /*#__PURE__*/ _jsx(LearnMoreTag, {
                    url: __("https://devowl.io/knowledge-base/is-real-cookie-banner-legally-compliant/")
                })
            ]
        })
    });
};
export { FormContentBlockerFieldTemplateCheck };
